{
  "fr": {
    "pagination": {
      "next": "Page suivante",
      "page_report": "Page {page} sur {total}",
      "previous": "Page précédente",
      "report": "Affichage de {first} à {last} sur {total}",
      "total": "Total des éléments : {total}"
    }
  }
}
